export default __webpack_public_path__ + "static/media/023-bubble tea.b74ebb8a.svg";